import packageJson from '../../package.json';

export const environment = {
    production: true,
    apiEndpoint: 'https://www.corecommissions.net/api',
    samlEndpoint: 'https://www.corecommissions.net/SAML',
    webEndpoint: 'https://www.commportal.net',
    version: packageJson.version
};
